module.exports = __webpack_public_path__ + "img/leztroy-crm-logo-mobile.0558fc5e.png";